export default __webpack_public_path__ + "static/media/Enhanced_due_digilence.e06f4c0e.png";